import { render, staticRenderFns } from "./ModalSku.vue?vue&type=template&id=132abb2a&scoped=true"
import script from "./ModalSku.vue?vue&type=script&lang=js"
export * from "./ModalSku.vue?vue&type=script&lang=js"
import style0 from "./ModalSku.vue?vue&type=style&index=0&id=132abb2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132abb2a",
  null
  
)

export default component.exports